import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../store/store';
import { resetVisitor } from '../store/slices/visitorSlice';
import { setConfig, setCurrentLocation, setSelectedLanguage, resetPrimaryLanguage } from '../store/slices/appSlice';
import { setAuthFlow } from '../store/slices/authSlice';

export const useNewVisitorSession = () => {
    const dispatch = useDispatch<AppDispatch>();

    const startNewVisitorSession = () => {
        dispatch(setSelectedLanguage('en'));
        dispatch(resetVisitor());
        dispatch(setConfig(null));
        dispatch(setCurrentLocation(null));
        dispatch(resetPrimaryLanguage());
        dispatch(setAuthFlow(null));
        sessionStorage.removeItem('orgconfig');
    };

    return { startNewVisitorSession };
};
